module.exports = __webpack_public_path__ + "img/clinic.622bd57f.png";